import React from "react";
import { FiArrowLeft, FiHome, FiRefreshCw } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import WakoConfused from "../../../assets/mascots/wako/Confused.svg";
import WakoComingSoon from "../../../assets/mascots/wako/Coming_Soon.svg";
import WakoLost from "../../../assets/mascots/wako/Lost.svg";
import WakoMaintenance from "../../../assets/mascots/wako/Maintenance.svg";
import StatusPage from "./StatusPage";

export function NotFoundPage() {
  const navigate = useNavigate();

  return <StatusPage
    image={WakoLost}
    imageAlt="Wako buscando el camino"
    eyebrow="Error 404"
    title="Parece que nos perdimos"
    description="La página que buscas no existe, cambió de lugar o tomó otro sendero."
    primaryAction={{ label: "Volver al inicio", icon: <FiHome/>, onClick: () => navigate("/") }}
    secondaryAction={{ label: "Regresar", icon: <FiArrowLeft/>, onClick: () => navigate(-1) }}
  />;
}

export function OfflinePage() {
  return <StatusPage
    image="/mascots/wako-unplugged.svg"
    imageAlt="Wako sin conexión"
    eyebrow="Sin conexión"
    title="Nos quedamos sin señal"
    description="Revisa tu conexión a internet. Cuando vuelva, continuaremos justo donde estabas."
    primaryAction={{ label: "Reintentar", icon: <FiRefreshCw/>, onClick: () => window.location.reload() }}
  />;
}

export function ErrorPage({ onRetry = () => window.location.reload() }) {
  return <StatusPage
    image={WakoConfused}
    imageAlt="Wako encontró un problema"
    eyebrow="Algo salió mal"
    title="Tuvimos un pequeño tropiezo"
    description="No pudimos completar esta parte. Puedes intentarlo de nuevo; si continúa, vuelve más tarde."
    primaryAction={{ label: "Intentar de nuevo", icon: <FiRefreshCw/>, onClick: onRetry }}
    secondaryAction={{ label: "Ir al inicio", icon: <FiHome/>, onClick: () => window.location.assign("/") }}
  />;
}

export function MaintenancePage() {
  const navigate = useNavigate();

  return <StatusPage
    image={WakoMaintenance}
    imageAlt="Wako dando mantenimiento"
    eyebrow="En mantenimiento"
    title="Estamos afinando esta aventura"
    description="Hacemos algunos ajustes para que todo funcione mejor. Estaremos de vuelta muy pronto."
    primaryAction={{ label: "Volver al inicio", icon: <FiHome/>, onClick: () => navigate("/") }}
  />;
}

export function ComingSoonPage({ embedded = false }) {
  const navigate = useNavigate();

  return <StatusPage
    image={WakoComingSoon}
    imageAlt="Wako preparando una nueva sección"
    eyebrow="Próximamente"
    title="Una nueva aventura está en camino"
    description="Todavía estamos construyendo esta sección. Muy pronto habrá algo especial por descubrir."
    primaryAction={{ label: "Volver al inicio", icon: <FiHome/>, onClick: () => navigate("/") }}
    secondaryAction={{ label: "Regresar", icon: <FiArrowLeft/>, onClick: () => navigate(-1) }}
    showTopbar={!embedded}
  />;
}
